import { useEffect } from "react";
import { useSession } from "../state/session.js";
import { useLoad } from "../state/useLoad.js";
import { applyBrandHead } from "./head.js";

/**
 * Swaps the favicon and the page title for the user's primary company (the first one; real
 * companies come before demos). Renders nothing; failures leave the Uzverse defaults.
 */
export function BrandHead() {
  const { services } = useSession();
  const org = useLoad(() => services.api.listOrganization());
  const branding = org.data?.[0]?.branding ?? null;
  useEffect(() => {
    applyBrandHead(document, branding);
    return () => applyBrandHead(document, null);
  }, [branding]);
  return null;
}
